import React from 'react';
import ResourceProperty from '../../../../common/resource/ResourceProperty';
import detractionBasicInformationPropTypes from '../proptypes/LiquidationDifferenceReasonPropTypes';

const LiquidationDifferenceReasonBasicInformationResource = ({
  name,
  description
}) => (
  <>
      <ResourceProperty label="Nombre:">{name}</ResourceProperty>
      <ResourceProperty label="Descripción:">{description}</ResourceProperty>
  </>
);

LiquidationDifferenceReasonBasicInformationResource.propTypes =
  detractionBasicInformationPropTypes;

export default LiquidationDifferenceReasonBasicInformationResource;
